import React from 'react';
import { Navigate } from 'react-router-dom';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import ListTablePage from '../../components/templates/listTableTemplate/listTableTemplate';
import viewSportsRoom from '../../config/viewSportsRoom';
import viewMainhubConfigs from '../../config/viewMainhubConfigs';
import viewMainHubConfigForm from '../../config/viewMainHubConfigForm';
import viewMainhubConfigNew from '../../config/viewMainhubConfigNew';
import viewMainhubConfigEdit from '../../config/viewMainhubConfigEdit';
import viewMainhubClientConfig from '../../config/viewMainhubClientConfig';
import viewMainHubCustomization from '../../config/viewMainHubCustomization';
import viewYoutubeCategories from '../../config/viewYoutubeCategories';
import viewYoutubeInteractables from '../../config/viewYoutubeInteractables';
import viewYoutubeCategoryContentForm from '../../config/viewYoutubeCategoryContentForm';
import viewYoutubeInteractableContentForm from '../../config/viewYoutubeInteractableContentForm';
import viewMainHubThirdParty from '../../config/viewMainHubThirdParty';
import viewMainHubThirdPartyAuthProviderNew from '../../config/viewMainHubThirdPartyAuthProviderNew';
import viewMainHubThirdPartyAuthProviderEdit from '../../config/viewMainHubThirdPartyAuthProviderEdit';
import viewInfoSectionsWhiteLabelPro from '../../config/viewInfoSectionsWhiteLabelPro';
import viewAppHomeForm from '../../config/viewAppHomeForm';
import viewMainHubGeneralSettings from '../../config/viewMainHubGeneralSettings';

export const mainHubRoutes = [
  {
    path: 'home',
    element: <FormTemplate configFile={viewAppHomeForm} />,
  },
  {
    path: 'generalSettings',
    element: <FormTemplate configFile={viewMainHubGeneralSettings} />,
  },
  {
    path: 'space',
    element: <ListTablePage configFile={viewSportsRoom} />,
  },

  {
    path: 'configs',
    element: <ListTablePage configFile={viewMainhubConfigs} />,
  },
  {
    path: 'configs/new',
    element: <FormTemplate configFile={viewMainhubConfigNew} />,
  },
  {
    path: 'configs/edit/:configId',
    element: <FormTemplate configFile={viewMainhubConfigEdit} />,
  },
  {
    path: 'configs/rules/:configId',
    element: (
      <FormTemplate
        configFile={viewMainHubConfigForm}
        pagePermissions={[
          { name: 'Create', data: ['BlackLabel.ManageConfigs.Create', 'Xtadium'] },
          { name: 'Save', data: ['BlackLabel.ManageConfigs.Update', 'Xtadium'] },
          { name: 'Delete', data: ['BlackLabel.ManageConfigs.Delete', 'Xtadium'] },
        ]}
        createPermission={['BlackLabel.ManageConfigs.Create', 'Xtadium']}
        updatePermission={['BlackLabel.ManageConfigs.Update', 'Xtadium']}
        deletePermission={['BlackLabel.ManageConfigs.Delete', 'Xtadium']}
      />
    ),
  },

  {
    path: 'customization',
    element: <FormTemplate configFile={viewMainHubCustomization} />,
  },

  {
    path: 'mhClientConfig/:configSlug?',
    element: <FormTemplate configFile={viewMainhubClientConfig} />,
  },

  {
    path: 'infoSections',
    element: <FormTemplate configFile={viewInfoSectionsWhiteLabelPro} />,
  },

  {
    path: 'thirdPartyProviders',
    element: <ListTablePage configFile={viewMainHubThirdParty} />,
  },
  {
    path: 'thirdPartyProviders/new',
    element: (
      <FormTemplate configFile={viewMainHubThirdPartyAuthProviderNew} />
    ),
  },
  {
    path: 'thirdPartyProviders/:id',
    element: (
      <FormTemplate configFile={viewMainHubThirdPartyAuthProviderEdit} />
    ),
  },

  {
    path: 'youtube/categories',
    element: <ListTablePage configFile={viewYoutubeCategories} />,
  },
  {
    path: 'youtube/categories/new',
    element: <FormTemplate configFile={viewYoutubeCategoryContentForm} />,
  },
  {
    path: 'youtube/categories/:categoryId',
    element: <FormTemplate configFile={viewYoutubeCategoryContentForm} />,
  },

  {
    path: 'youtube/interactables',
    element: <ListTablePage configFile={viewYoutubeInteractables} />,
  },
  {
    path: 'youtube/interactables/new',
    element: <FormTemplate configFile={viewYoutubeInteractableContentForm} />,
  },
  {
    path: 'youtube/interactables/:interactableId',
    element: <FormTemplate configFile={viewYoutubeInteractableContentForm} />,
  },
  {
    index: true,
    element: <Navigate to="home" replace />,
  },
];
